import React, { memo } from 'react'
import { useCallback, useState } from 'sb-hooks'
import cx from 'classnames'

import Image, { ImageProps } from 'components/_new/ui/Image/Image'
import PlaceholderImage from 'components/_new/ui/PlaceholderImage/PlaceholderImage'

import s from './ImageWithPlaceholderFallback.scss'


type ImageWithPlaceholderFallbackProps = ImageProps & {
  className?: string
  imageClassName?: string
}

// Component is image with container. This is glue between new Image component and old Picture
const ImageWithPlaceholderFallback: React.FunctionComponent<ImageWithPlaceholderFallbackProps> = (props) => {
  const [ isError, setError ] = useState<boolean>(false)

  const handleImageError = useCallback(() => {
    setError(true)
  }, [])

  const { className, w, h, ...rest } = props

  const containerClassName = cx(className, s.container)

  const imageClassName = cx(className, s.image, {
    [s.vertical]: Boolean(h),
    [s.horizontal]: Boolean(w),
  })

  const imageProps = {
    className: imageClassName,
    w,
    h,
    ...rest,
  }

  return (
    <figure className={containerClassName}>
      {
        isError ? (
          <PlaceholderImage {...imageProps} />
        ) : (
          <Image
            {...imageProps}
            onError={handleImageError}
          />
        )
      }
    </figure>
  )
}


export default memo(ImageWithPlaceholderFallback)
